<app-breadcrumb [master]="'Administracja'" [parentName]="'Licencje'" [name]="'Lista'"></app-breadcrumb>
<div fxLayout="column" fxLayoutGap="15px" class="list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="list-filters">
    <app-dynamic-dict class="list-filter"
                      [multiple]="false"
                      [dictType]="DYNAMIC_DICTIONARY_LICENSE_TYPE"
                      [label]="'Rodzaj licencji'"
                      [(ngModel)]="initialFilters.typeOfLicense" name="typeOfLicense">
    </app-dynamic-dict>

    <mat-form-field class="list-filter">
      <mat-label>Użytkownik</mat-label>
      <input matInput placeholder="Jan Kowalski" name="username" [(ngModel)]="initialFilters.username">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Numer licencji</mat-label>
      <input matInput name="contains$licenseNumber" [(ngModel)]="initialFilters.contains$licenseNumber">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Urządzenie</mat-label>
      <input matInput name="deviceName" [(ngModel)]="initialFilters.deviceName">
    </mat-form-field>

    <app-datepicker
      class="list-filter"
      label="Data ważności od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$expirationDate" name="gte$expirationDate"
    ></app-datepicker>

    <app-datepicker
      class="list-filter"
      label="Data ważności do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$expirationDate" name="lte$expirationDate"
    ></app-datepicker>
  </form>

  <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-between center">
    <div>
      <button *ngIf="(userPermissions | async).license.write"  (click)="addLicense()" mat-stroked-button color="primary">
        <mat-icon>add</mat-icon> <span> Dodaj </span>
      </button>
    </div>

    <div fxLayout="row" fxLayoutGap="15px">
      <button *ngIf="(userPermissions | async).license.read_report" (click)="downloadReport()"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span>
      </button>
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource">

    <ng-container matColumnDef="licenseNumber">
      <th mat-header-cell *matHeaderCellDef> Numer licencji </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="!disableLinks">
          <a class="default-link" [routerLink]="['/licencje/szczegoly', element.uuid]">{{element.licenseNumber}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="licenseType">
      <th mat-header-cell *matHeaderCellDef> Rodzaj licencji </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.typeOfLicense?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.user">
          <a class="default-link" [routerLink]="['/licencje/uzytkownicy/szczegoly', element.user.uuid]">{{element.user.firstName +' '+ element.user.lastName}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="expirationDate">
      <th mat-header-cell *matHeaderCellDef> Data ważności do </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element?.expirationDate">{{element?.expirationDate | date: 'yyyy-MM-dd'}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="deviceName">
      <th mat-header-cell *matHeaderCellDef> Urządzenie </th>
      <td mat-cell *matCellDef="let element"> {{element?.device?.name}} </td>
    </ng-container>

    <ng-container matColumnDef="note">
      <th mat-header-cell *matHeaderCellDef> Notatka </th>
      <td mat-cell *matCellDef="let element"> {{element?.note}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
